import { batchSteps } from './batch-steps-action';
export var batchAttributeUpdatesPlugin = function batchAttributeUpdatesPlugin() {
  return {
    name: 'batchAttributeUpdates',
    actions: {
      batchSteps: batchSteps
    }
  };
};